//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


// Func = limiting Scope for this file
(function(){
	
	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});
	

	//mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
			document.getElementById('menutextjs').innerHTML = "Close";
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
			document.getElementById('menutextjs').innerHTML = "Menu";
		
		}
	});
	$(document).ready(function () {
		  
		$('.information-tabs__imagen--img').hide();
		$('.information-tabs__imagen--img:first').show();
		$('.information-tabs__imagen--img:first').addClass('active');
		$('.information-tabs__item:first').addClass('active');
		$('.information-tabs__nav > li').click(function(event) {
		  $('.information-tabs__item').removeClass('active');
		  $(this).addClass('active');
		  $('.information-tabs__imagen--img').hide();
		  var selectTab = $(this).attr("data-target");
		  $(selectTab).fadeIn();
		});
	}());



}());

	//booking widget
	// document.querySelector("#js-booking").addEventListener("click", function (e) {
    //     e.preventDefault();
    //     document.querySelector(".booking-widget").classList.add("open");
    //   });

    // document.querySelector("#js-close").addEventListener("click", function (e) {
    //   e.preventDefault();
    //   document.querySelector(".booking-widget").classList.remove("open");
    // });

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > 80){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('down')){
					 document.getElementById('header').classList.add('down');
					 document.getElementById('header').classList.remove('up');
					//document.getElementById('header').classList.add('internal')
					
					
				}
			} else {
				
				
				//upscroll code
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
					//document.getElementById('header').classList.remove('internal');
					
				}
			}
		} else {
			// if(document.getElementById('home') && document.getElementById('header').classList.contains('down')){
			// 	document.getElementById('header').classList.remove('down');
			// 	if(windowWidth > 600){
			// 		logoUrl = site_url + 'assets/svg/logo.svg';
			// 		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
			// 	}
			// }
			
			if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.remove('up');
				document.getElementById('header').classList.remove('down');
				// if(document.getElementById('home') && windowWidth > 600) {
				// 	logoUrl = site_url + 'assets/svg/logo.svg';
				// 	document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
				// }
			}
			// if(!document.getElementById('home') && !document.getElementById('header').classList.contains('internal')){
				
			// 	document.getElementById('header').classList.add('internal');
			// }
		}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
	
	
}



//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}